<template>
  <el-config-provider :locale="currentLocale">
    <router-view />
    <ReDialog />
    <ReDrawer />
  </el-config-provider>
</template>

<script lang="ts">
import { defineComponent, h, ref } from "vue";
import { ElConfigProvider } from "element-plus";
import { ReDialog } from "@/components/ReDialog";
import { ReDrawer } from "@/components/ReDrawer";
import en from "element-plus/es/locale/lang/en";
import zhCn from "element-plus/es/locale/lang/zh-cn";

export default defineComponent({
  name: "app",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
    ReDialog,
    ReDrawer
  },
  computed: {
    currentLocale() {
      return this.$storage.locale?.locale === "zh" ? zhCn : en;
    }
  },
  mounted() {
    function printAppInfo(): void {
      const app = __APP_INFO__;
      const commitInfo = `commit: %c${app.commit} %cbuild: %c${app.lastBuildTime}`;

      const keyStyle = `color:#606266;font-weight:bold;font-family:'Consolas'`;
      const valueStyle = `color:#2c3e50;font-family:'Consolas'`;

      console.log(
        `%c${commitInfo}`,
        keyStyle,
        valueStyle,
        keyStyle,
        valueStyle
      );
    }

    if (import.meta.env.MODE === "production") {
      printAppInfo();
    }
  }
});
</script>
